import { FormAddress } from '@/models/common/address';
import { LocationModel } from '@/models/common/location';
import { TimeHelper } from '@/helpers/TimeHelper';

class FarmModel {
  id;
  organisationId;
  createdOn;
  name;
  description;
  email;
  phone;
  timezone;
  address;
  location;
  status;

  constructor(data) {
    this.populate(data || {});
  }

  get dateCreated() {
    return TimeHelper.formatDate(this.createdOn);
  }

  populate(data) {
    this.id = data.id || null;
    this.organisationId = data.organisationId || null;
    this.createdOn = data.createdOn || null;
    this.name = data.name || '';
    this.description = data.description || '';
    this.status = data.status || '';
    this.email = data.email || '';
    this.phone = data.phone || '';
    this.timezone = data.timezone || '';
    this.address = new FormAddress(data.address || null);
    this.location = new LocationModel(data.location || null);
  }

  toDetailsUpdateJson(originalData) {
    let output = {};
    if (this.organisationId !== originalData.organisationId) output.organisationId = this.organisationId;
    if (this.name !== originalData.name) output.name = this.name;
    if (this.phone !== originalData.phone) output.phone = this.phone;
    if (this.email !== originalData.email) output.email = this.email;
    if (this.timezone !== originalData.timezone) output.timezone = this.timezone;
    if (this.description !== originalData.description) output.description = this.description;
    if (this.status !== originalData.status) output.status = this.status;
    if (this.location.hasChanged(originalData.location)) {
      output.location = this.location;
    }
    output.address = this.address;
    return output; // TODO first check if object is empty
  }

  exportToCreate() {
    return {
      organisationId: this.organisationId,
      name: this.name,
      email: this.email,
      timezone: this.timezone
    };
  }
}

export { FarmModel };
